import './ShipmentDetails.scss'
import { useRebookingHistory } from '../../../common/hooks/useRebookingHistory'
import { Snack, Spinner } from '@nike/eds'
import { SimpleTable } from '../../../common/components/table/SimpleTable'
import { shipmentRebookingsColumns } from './ShipmentRebookingsColumns'

export function ShipmentRebookings({ shipment }) {
  const { data: rebookingHistoryData, isSuccess: isRebookingHistoryCallSuccess } =
    useRebookingHistory(shipment.packlistNumber)

  // Add some extra fields to each rebooking entry for comparison purpose in the column renderers
  if (isRebookingHistoryCallSuccess) {
    rebookingHistoryData.forEach((reb) => {
      reb.originalIdpPlannedTimestamp = shipment.iDPPlannedTimestamp
      reb.originalPlannedDeliveryFromTime = shipment.plannedDeliveryFromTimestamp
      reb.originalPlannedDeliveryToTime = shipment.plannedDeliveryToTimestamp
    })
  }

  return (
    <div>
      {isRebookingHistoryCallSuccess ? (
        rebookingHistoryData.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <SimpleTable columns={shipmentRebookingsColumns} data={rebookingHistoryData} />
          </div>
        ) : (
          <Snack id="no-rebookings-snack" hideDismiss={true} status="info">
            No rebooking information found
          </Snack>
        )
      ) : (
        <Spinner size="large" />
      )}
    </div>
  )
}
